function cart_ul_height(){
  var win_hgt = $(window).height();
  var tp_div_hgt = $('.cart_slider_title').height();
  var btm_div_hgt = $('.cart_footer_section').height();
  var cnt_ul_hgt = win_hgt - tp_div_hgt - btm_div_hgt - 50;
  $('ul.cart_slider_items_section').css('max-height', cnt_ul_hgt);
}

function get_cart_items_number(){
  jQuery.getJSON('/cart.js', function(cart) {
    $('.cart_total_items_cls').html(cart.item_count);
  });
}

$('.cart_right_canvas_btn').click(function(){
  ajaxCart.load();
  cart_ul_height();
});

$('.wish-list').submit(function(evt) {
  evt.preventDefault();
  postToWishlist();
  
  return false;
});

$('.wishlist_addtocart_form').submit(function(evt) {
  evt.preventDefault();
  ShopifyAPI.addItemFromForm(evt.target);
  setTimeout(function(){
    $('.js-remove-button').trigger("click");
  },1000);
  
  return false;
});

$(window).resize(function () {
  cart_ul_height();
});

$('#AddToCartForm').submit(function(e) {
  e.preventDefault();
  
  ajaxCart.load();
  $('.cart_right_canvas_btn').trigger("click");
  get_cart_items_number();
  
  return false;
});

$('.product_grid_form_cls').submit(function(evt) {
  ShopifyAPI.addItemFromForm(evt.target);
  return false;
});

$('#add-item-qv').submit(function(evt) {
  ShopifyAPI.addItemFromForm(evt.target);
  return false;
});

/*---------   Cart off-canvas   ---------*/

$('header .cart_right_canvas_btn').click(function(e) {
  $('body').toggleClass("body_fix_size_cls");
});

$('.cart_offcanvas_section .close-button').click(function(e) {
  if($('body').hasClass("body_fix_size_cls")) {
    $('body').removeClass("body_fix_size_cls");
  }
});

$('.js-off-canvas-overlay').click(function(e) {
  if($('body').hasClass("body_fix_size_cls")) {
    $('body').removeClass("body_fix_size_cls");
  }
});